export const grandTitleConfig = {
    headings: [
        {
            headingLabel: "Active",
            width: "11%",
            inputType: "checkbox"
        },
        {
            headingLabel: "Grand Title",
            width: "77%",
            inputType: "text"
        },

    ],
    dataNodes: ["is_active", "name"],
    primaryKey: "id",
    nodeFields: [
        {
            column: "is_active",
            icon: "check"
        },
    ],
    actions: ["pen", "times"],
    inlineEdits: [
        {
            dataNode: "is_active",
            width: "10%"
        },
        {
            dataNode: "name",
            width: "77%"
        }
    ],
}